import apiClient from "../utils/axiosPetition";

export const login = async (email, password) => {
    try {
        const response = await apiClient.post('api/auth/login', { username: email, password });
        return response.data;
    } catch (error) {
        return { ok: false, error: error.response ? error.response.data.message : error.message };
    }
}

export const reenviarCodigoLogin = async (username) => {
    try {
        const response = await apiClient.post('api/auth/reenviar-codigo-login', { username });
        return response.data;
    } catch (error) {
        return { ok: false, error: error.response ? error.response.data.message : error.message };
    }
}

export const verificarCodigoLogin = async (codigo, username) => {
    console.log(codigo, username)
    try {
        const response = await apiClient.post('api/auth/validar-codigo-login', { code: codigo, username: username });
        return response.data;
    } catch (error) {
        console.log(error)
        return { ok: false, error: error.response ? error.response.data.message : error.message };
    }
}

export const enviarCodigoPassword = async (username) => {
    try {
        const response = await apiClient.post('api/auth/enviar-codigo-password', { username: username });
        return response.data;
    } catch (error) {
        return { ok: false, error: error.response ? error.response.data.message : error.message };
    }
}

export const verificarCodigoPassword = async (codigo, username) => {
    try {
        const response = await apiClient.post('api/auth/validar-codigo-password', { code: codigo, username });
        return response.data;
    } catch (error) {
        return { ok: false, error: error.response ? error.response.data.message : error.message };
    }
}

export const cambioPassword = async (username, password, code) => {
    try {
        const response = await apiClient.put('api/auth/reset-password', { username, password, code });
        return response.data;
    } catch (error) {
        return { ok: false, error: error.response ? error.response.data.message : error.message };
    }
}